import { TransactionLabelTextHelper } from '../labelTextHelper/TransactionLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['dateCreateAt', 'dateModifyAt'];

export const TransactionHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            {
                text: TransactionLabelTextHelper.getLabelText.dateTransactionOn,
                value: 'dateTransactionOn',
                format: 'date'
            },
            { text: TransactionLabelTextHelper.getLabelText.transactionSource, value: 'transactionSource' },
            { text: TransactionLabelTextHelper.getLabelText.transactionType, value: 'transactionType' },
            {
                text: TransactionLabelTextHelper.getLabelText.transactionAmountBaseCurrency,
                value: 'transactionAmountBaseCurrency'
            },
            { text: TransactionLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: TransactionLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            {
                text: TransactionLabelTextHelper.getLabelText.dateOrderOn,
                value: 'dateOrderOn',
                format: 'date'
            },
            { text: TransactionLabelTextHelper.getLabelText.baseCurrencyCode, value: 'baseCurrencyCode' },
            { text: TransactionLabelTextHelper.getLabelText.foreignCurrencyCode, value: 'foreignCurrencyCode' },
            {
                text: TransactionLabelTextHelper.getLabelText.exchangeRateForeignCurrencyToBaseCurrency,
                value: 'exchangeRateForeignCurrencyToBaseCurrency'
            },
            {
                text: TransactionLabelTextHelper.getLabelText.dateCalculationAt,
                value: 'dateCalculationAt',
                format: 'datetime'
            },
            {
                text: TransactionLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: TransactionLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: TransactionLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
